export default __webpack_public_path__ + "static/2-0d3fe826fbe021ad981c8515917eab63.jpg";